import React from 'react'
import TitleWithIcon from '../TitleWithIcon'
import VisDiv from '../frontend_components/VisDiv'
import Divider from '../frontend_components/Divider'


   const DeviceFamily = ({data}) => {
      const {deviceFamily, registerTemplateDevices} = data 
      const onRowClick = () => {
         console.log("DATA", data)
         console.log("registerTemplateDevice", registerTemplateDevice)
      } 
      //console.log("IN CONSOLE DEV FAMILY", registerTemplateDevices)
      const registerTemplateDevice = !Array.isArray(registerTemplateDevices) ? undefined : registerTemplateDevices?.find?.((x)=>x?._id == deviceFamily?.templateDeviceId)
      return (
         <div onClick={onRowClick} className='offer-device-family-header-container'>
            <h4 style={{marginLeft:"30px"}}>{registerTemplateDevice?.label}</h4>
         </div>
       )
     }

export default DeviceFamily

